// React
import { useHistory } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injection
import { notifyError } from '../../containers/componentsInjection';
import { ReportsInjection } from '../../containers/reportsInjection';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { createData } from '../../../../utils/createData';
import { openPdfWithBase64 } from '../../../../utils/openPdfWithBase64';
import { APIClient, getLoggedinUser } from '../../../../helpers/api_helper';

// View
import { FinancialBillsToReceivePage } from './view';

export const FinancialBillsToReceive = () => {
  let offices = getLoggedinUser().data.offices;
  let hasSingleOffice = Boolean(offices.length === 1);

  const [selectedOffice, setSelectedOffice] = useState(
    hasSingleOffice && {
      label: offices[0].name,
      value: offices[0].office_id,
    }
  );

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();
  const { getOrganizations, organizations } = ReportsInjection();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      periodStarts: '',
      periodEnds: '',
      organizationInput: '',
    },
    validationSchema: Yup.object({
      periodStarts: Yup.string().nullable(),
      periodEnds: Yup.string().nullable(),
      organizationInput: Yup.object().shape({
        label: Yup.string().nullable(),
        value: Yup.string().nullable(),
      }),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        starts: values.periodStarts || null,
        ends: values.periodEnds || null,
        type: 'R',
        person: values.organizationInput.value || null,
        office: selectedOffice.value || null,
      };

      toggleLoading();
      api
        .create('/reports/financial/accounting', valuesToSubmit)
        .then((response) => {
          openPdfWithBase64(response.data, 'Contas a Receber');
        })
        .catch((error) => {
          notifyError(error.response.data.messages.error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    getOrganizations();
  }, []);

  return (
    <>
      <FinancialBillsToReceivePage
        // data
        offices={offices || []}
        organizations={organizations || []}
        // utilities
        history={history}
        createData={createData}
        validation={validation}
        selectedOffice={selectedOffice}
        setSelectedOffice={setSelectedOffice}
      />
    </>
  );
};
